import { useQuery } from '@ts-core/lib/apollo';

import { getErrorMessage } from '@ts-core/lib/apollo';
import { useSnackbarNotifications } from '@ts-core/core/hooks/ui';

import { FinishedPracticeSession } from '../types';
import {
  getPracticeSessionDetailsQuery,
  GetPracticeSessionDetailsQueryResult,
  GetPracticeSessionDetailsQueryVariables,
} from '../graphql/queries/getPracticeSessionDetailsQuery';

export interface PracticeSessionDetailsHookInput {
  courseId: string;
  practiceSessionId: string;

  notifyErrors?: boolean;
}

export interface PracticeSessionDetailsHookPayload {
  practiceSession?: FinishedPracticeSession;
  loading: boolean;
  error?: string;
}

export default function usePracticeSessionResult(input: PracticeSessionDetailsHookInput): PracticeSessionDetailsHookPayload {
  const { courseId, practiceSessionId, notifyErrors = true } = input;
  const { showErrorNotification } = useSnackbarNotifications();

  const { data, loading, error } = useQuery<GetPracticeSessionDetailsQueryResult, GetPracticeSessionDetailsQueryVariables>(
    getPracticeSessionDetailsQuery,
    {
      variables: {
        courseId,
        practiceSessionId,
      },
      onError: notifyErrors ? showErrorNotification : undefined,
    }
  );

  return {
    practiceSession: data?.finishedPracticeSession,
    loading,
    error: getErrorMessage({ error }),
  };
}
